<template>
  <div :class="isMobile?'box-mb':'box'">
    <div class="title">CHINA VALVE（HANGZHOU）2026</div>
    <div class="flex">
      <div class="lt">
        <div class="p">Faculty and Presenters will be automatically registered by the secretariat.</div>
        <div class="p">lf you have any questions about the conference or registration, please contact cvh2025@china-valve.org.cn </div>
      </div>
      <div class="rt">
        <div class="h">Sign up</div>
        <div class="line"></div>
        <div class="y-btn" @click="goPage('https://www.drvoice.cn/v2/conf/1689/delegationRegister?type=delegate&language=en')">New User Registration</div>
        <div class="y-btn" @click="goPage('https://www.drvoice.cn/v2/conf/1689/delegationRegister?type=delegate')">境内代表请点击此处注册</div>
        <div class="w-btn" @click="goPage('https://www.drvoice.cn/v2/conf/1689/conferenceLogin?type=delegate&language=en')">Log In</div>
      </div>
    </div>
  </div>
</template>

<script>
import {isMobile} from "../utils/util";

export default {
  data() {
    return {
      isMobile: isMobile()
    }
  },
  methods: {
    goPage(url){
      window.location.href = url
    }
  }
}
</script>

<style lang="less" scoped>

.box {
  max-width: 800px;
  min-height: 600px;
  margin: 0 auto;
  .title {
    padding-top: 60px;
    font-size: 26px;
    font-weight: bold;
    color: #17227c;
    border-bottom: 2px solid #17227c;
  }
  .flex {
    font-size: 16px;
    padding-top: 40px;
    display: flex;
    .lt {
      flex: 1;
      position: relative;
      border-radius: 8px;
      overflow: hidden;
      color: #17227c;
      padding: 80px 20px 0;
      // background-color: #f3f4f7;
      .p {
        margin-bottom: 1em;
        font-weight: bold;
      }
      &::before {
        content: '';
        background-image: url('https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2024/12/31/7f122a1cbe9f49d4813c4b9399f29bab.jpg');
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        z-index: -1;
        opacity: 0.06;
      }
    }
    .rt {
      width: 300px;
      margin-left: 30px;
      background-color: #19317e;
      border-radius: 8px;
      padding: 20px 20px 80px;
      font-weight: bold;
      color: #222;
      .h {
        color: #fff;
        line-height: 3em;
        border-bottom: 1px solid #fff;
        margin-bottom: 30px;
      }
      .y-btn {
        font-size: 14px;
        background-color: #f8b301;
        margin-bottom: 40px;
        border-radius: 4px;
        padding: 8px;
        text-align: center;
        cursor: pointer;
      }
      .w-btn {
        font-size: 14px;
        background-color: #fff;
        border-radius: 4px;
        padding: 8px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
.box-mb {
  padding: 20px 10px;
  .title {
    padding-top: 20px;
    font-size: 20px;
    font-weight: bold;
    color: #17227c;
    border-bottom: 2px solid #17227c;
  }
  .flex {
    font-size: 16px;
    padding-top: 40px;
    .lt {
      flex: 1;
      position: relative;
      border-radius: 8px;
      overflow: hidden;
      color: #17227c;
      padding: 20px 20px 0;
      // background-color: #f3f4f7;
      .p {
        margin-bottom: 1em;
        font-weight: bold;
      }
      &::before {
        content: '';
        background-image: url('https://drvoicedev.oss-cn-beijing.aliyuncs.com/drvoice/server/uploadfile/2024/12/31/7f122a1cbe9f49d4813c4b9399f29bab.jpg');
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        z-index: -1;
        opacity: 0.06;
      }
    }
    .rt {
      background-color: #19317e;
      border-radius: 0 0 8px 8px;
      padding: 20px 20px 80px;
      font-weight: bold;
      color: #222;
      .h {
        color: #fff;
        line-height: 3em;
        border-bottom: 1px solid #fff;
        margin-bottom: 30px;
      }
      .y-btn {
        font-size: 14px;
        background-color: #f8b301;
        margin-bottom: 40px;
        border-radius: 4px;
        padding: 8px;
        text-align: center;
        cursor: pointer;
      }
      .w-btn {
        font-size: 14px;
        background-color: #fff;
        border-radius: 4px;
        padding: 8px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
</style>
